import { Currency } from "@redotech/money/currencies";
import {
  createCurrencyConverter,
  CurrencyConverter,
} from "@redotech/money/exchange";
import { RpcClientContext } from "@redotech/redo-customer-portal-shared/contexts/rpc";
import { lazy } from "@redotech/util/cache";
import { createContext, ReactNode, useContext, useMemo } from "react";

export const CurrencyExchangeContext = createContext<
  () => Promise<CurrencyConverter>
>(async () => {
  throw new Error("Not provided");
});

export const CurrencyExchangeProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const rpcClient = useContext(RpcClientContext);
  const currencyConverter = useMemo(
    () =>
      lazy(async () => {
        if (!rpcClient) {
          return createCurrencyConverter(new Map());
        }
        const exchangeRates = await rpcClient.getExchangeRates(null);
        const rates = new Map<Currency, number>();
        for (const [key, value] of Object.entries(exchangeRates)) {
          if (value !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            rates.set(key as Currency, value);
          }
        }
        return createCurrencyConverter(rates);
      }),
    [rpcClient],
  );

  return (
    <CurrencyExchangeContext.Provider value={currencyConverter}>
      {children}
    </CurrencyExchangeContext.Provider>
  );
};
